module.exports = __webpack_public_path__ + "img/typeRed.3a5d59fa.png";